import { useMutation } from '@tanstack/react-query';
import apiRequest from '../../services/apiWrapper';
import { USERS_URL } from '../../utils/constants/urlConstants';
import { STATUSRev } from '../../utils/constants/users/status';

async function fetchExportStudents(searchParams: URLSearchParams) {
  const params = new URLSearchParams(searchParams);
  const status = params.get('status');

  params.delete('role');

  if (status) {
    const statusInt = STATUSRev[status.toUpperCase() as keyof typeof STATUSRev];
    if (statusInt !== undefined) {
      params.set('status', statusInt.toString());
    }
  }

  return await apiRequest.get(
    `${USERS_URL}/students/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
}

export function useExportStudents(searchParams: URLSearchParams) {
  return useMutation({
    mutationFn: () => fetchExportStudents(searchParams),
  });
}
